import { MapPin, Phone, MessageCircle, Instagram } from "lucide-react";
import { GYM, waLink } from "@/lib/gymData";

export const Visit = () => {
  return (
    <section id="visit" data-testid="visit-section" className="relative bg-obsidian py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-12 max-w-2xl">
          <p className="text-blaze text-xs uppercase tracking-[0.3em] mb-4">Visit Us</p>
          <h2 className="font-display text-white text-5xl sm:text-6xl xl:text-7xl leading-[0.9] tracking-tight">
            FIND US HERE
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Info */}
          <div className="flex flex-col gap-5">
            <div className="border border-white/10 p-7 rounded-sm">
              <div className="flex items-start gap-4">
                <MapPin className="text-blaze shrink-0 mt-1" size={22} />
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-1">Address</p>
                  <p className="text-white font-medium">{GYM.address.line1}</p>
                  <p className="text-neutral-300 text-sm">{GYM.address.line2}</p>
                  <p className="text-neutral-300 text-sm">{GYM.address.line3}</p>
                </div>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-5">
              <a
                href={`tel:${GYM.phone}`}
                data-testid="visit-call-link"
                className="group border border-white/10 p-7 rounded-sm hover:border-blaze transition-colors"
              >
                <Phone className="text-blaze mb-3" size={22} />
                <p className="text-xs uppercase tracking-[0.2em] text-neutral-500">Phone</p>
                <p className="text-white font-medium group-hover:text-blaze transition-colors">{GYM.phone}</p>
              </a>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="visit-whatsapp-link"
                className="group border border-white/10 p-7 rounded-sm hover:border-whatsapp transition-colors"
              >
                <MessageCircle className="text-whatsapp mb-3" size={22} />
                <p className="text-xs uppercase tracking-[0.2em] text-neutral-500">WhatsApp</p>
                <p className="text-white font-medium group-hover:text-whatsapp transition-colors">{GYM.phone}</p>
              </a>
            </div>

            <a
              href={GYM.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="visit-instagram-link"
              className="group border border-white/10 p-7 rounded-sm hover:border-blaze transition-colors flex items-center gap-4"
            >
              <Instagram className="text-blaze" size={22} />
              <div>
                <p className="text-xs uppercase tracking-[0.2em] text-neutral-500">Instagram</p>
                <p className="text-white font-medium group-hover:text-blaze transition-colors">@{GYM.instagram}</p>
              </div>
            </a>
          </div>

          {/* Map */}
          <div className="border border-white/10 rounded-sm overflow-hidden min-h-[360px] lg:min-h-full">
            <iframe
              title="Fitness Point Gym Location"
              data-testid="map-embed"
              src={GYM.mapsEmbed}
              className="w-full h-full min-h-[360px]"
              style={{ border: 0, filter: "invert(0.92) hue-rotate(180deg)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};
